import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowUpIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M13.63 12.2C13.7472 12.3118 13.903 12.3743 14.065 12.3743C14.227 12.3743 14.3828 12.3118 14.5 12.2L15.23 11.47C15.3442 11.354 15.4082 11.1977 15.4082 11.035C15.4082 10.8722 15.3442 10.716 15.23 10.6L10.43 5.80997C10.3741 5.75252 10.3072 5.70685 10.2334 5.67567C10.1595 5.64448 10.0802 5.62842 10 5.62842C9.91983 5.62842 9.84047 5.64448 9.76662 5.67567C9.69276 5.70685 9.62591 5.75252 9.56999 5.80997L4.77 10.6C4.65579 10.716 4.59178 10.8722 4.59178 11.035C4.59178 11.1977 4.65579 11.354 4.77 11.47L5.5 12.2C5.61719 12.3118 5.77298 12.3743 5.935 12.3743C6.09701 12.3743 6.2528 12.3118 6.37 12.2L10 8.55997L13.63 12.2Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowUpIcon;
